import React from 'react';
import { Form, FormRenderProps } from 'react-final-form';
import { Box } from '@mui/material';

import { Button, Typography, Select } from '@occc-app/design-system';
import { Offer_Visible_Status } from '@occc/graphql';

import {
  EligibilityFilterSelectOption,
  EligibilityType,
  OffersFilterFormProps,
  OffersFilterFormValues,
  SourceFilterSelectOption,
  SourceFilterSelectOptionValueType,
  StatusFilterSelectOption,
} from './types';

const engagementTypeSelectOptions: SourceFilterSelectOption[] = [
  { label: 'Any', value: 'any' },
  { label: 'Reward', value: SourceFilterSelectOptionValueType.Reward },
  { label: 'Promotion', value: SourceFilterSelectOptionValueType.Promotion },
  { label: 'Offer/Challenge', value: SourceFilterSelectOptionValueType.OfferChallenge },
  { label: 'Punchcard', value: SourceFilterSelectOptionValueType.Punchcard },
  {
    label: 'Awards',
    value: SourceFilterSelectOptionValueType.Awards,
  },
  {
    label: 'Sweepstakes',
    value: SourceFilterSelectOptionValueType.Sweepstakes,
  },
  {
    label: 'Games',
    value: SourceFilterSelectOptionValueType.Games,
  },
  {
    label: 'Billboards',
    value: SourceFilterSelectOptionValueType.Billboards,
  },
];

const eligibilitySelectOptions: EligibilityFilterSelectOption[] = [
  { label: 'All', value: 'any' },
  { label: 'Eligible', value: EligibilityType.Eligible },
  { label: 'Not Eligible', value: EligibilityType.NotEligible },
];

const visibleStatusSelectOptions: StatusFilterSelectOption[] = [
  { label: 'All', value: 'any' },
  { label: 'Visible', value: Offer_Visible_Status.Visible },
  { label: 'No Voucher', value: Offer_Visible_Status.NoVoucher },
  { label: 'Expired', value: Offer_Visible_Status.Expired },
  { label: 'Unpublished', value: Offer_Visible_Status.Unpublished },
];

export const OffersFilterForm: React.FC<OffersFilterFormProps> = ({
  onSubmit,
  onReset,
  initialValues,
}) => {
  const renderForm: FormRenderProps<OffersFilterFormValues>['render'] = React.useCallback(
    ({ handleSubmit, form }: FormRenderProps<OffersFilterFormValues>) => {
      const reset = () => {
        form.reset();
        onReset();
      };

      return (
        <form onSubmit={handleSubmit}>
          <Box px={4} py={3} width={300}>
            <Box>
              <Typography paragraph>Component Type</Typography>
              <Select
                name='engagementType'
                label='Component Type'
                data={engagementTypeSelectOptions}
              />
            </Box>
            <Box mt={2}>
              <Typography paragraph>Eligibility</Typography>
              <Select name='eligibility' label='Eligibility' data={eligibilitySelectOptions} />
            </Box>
            <Box mt={2}>
              <Typography paragraph>Status</Typography>
              <Select name='visibleStatus' label='Status' data={visibleStatusSelectOptions} />
            </Box>
          </Box>
          <Box display='flex' justifyContent='flex-end' px={3} pb={2}>
            <Button size='small' color='error' onClick={reset}>
              Reset
            </Button>
            <Button type='submit' size='small' color='primary'>
              Apply
            </Button>
          </Box>
        </form>
      );
    },
    [onReset],
  );
  return (
    <Form<OffersFilterFormValues>
      onSubmit={onSubmit}
      render={renderForm}
      initialValues={initialValues}
    />
  );
};
